import { UserRes } from "@wl/types/lib/responses/user/user.res";

/**
 * User state.
 *
 * @export
 * @interface CharacterState
 */
export interface UserState {
    /**
     * User data.
     *
     * @type {UserRes}
     * @memberof CharacterState
     */
    current: UserRes | null;

    /**
     * User access token.
     *
     * @type {(string | null)}
     * @memberof CharacterState
     */
    token: string | null;
}

/**
 * Initial user module state
 *
 * @return {(() => UserState)} Initial user module state
 */
const state = (): UserState => ({
    current: null,
    token: null,
});

export default state;
